import { LazyExoticComponent } from "react";
import { IconType } from "react-icons/lib";

export enum UserRole {
  admin = "admin",
  adminSchool = "admin_school",
  student = "student",
  teacher = "teacher",
  inspecteur = "inspecteur",
  parent = "parent",
}

export interface RbacsProps {
  student?: JSX.Element;
  teacher?: JSX.Element;
  school?: JSX.Element;
  admin?: JSX.Element;
  adminSchool?: JSX.Element;
  // No modifications can be made as there is no selected code.startup?: JSX.Element;
  parent?: JSX.Element;
  inspecteur?: JSX.Element;
}

export interface RouteConf {
  path: string;
  component: LazyExoticComponent<() => JSX.Element>;
  access: { roles?: string[]; exclude?: string[] };
  menu: {
    title: string;
    icon: { size: number; icon: IconType };
    hasUnreadMsgBadge?: boolean;
  };
}

export enum ExerciseStatus {
  STANDBY = "in_standby",
  PROCESSING = "in_processing",
  ANSWERED = "resolved",
  REJECTED = "rejected",
}

export enum SubmissionType {
  CONTROL = "control",
  UNCLEAR = "unclear",
  BLOCAGE = "blocage",
}

export enum ReferenceType {
  LIVRE = "livre",
  EPREUVE = "epreuve",
  AUTRE = "other",
}

export interface ReferenceBook {
  name: string;
  page: number;
  exerciseNumber: number;
  _id: string;
}

export interface ReferenceEpreuve {
  session: string;
  class: string;
  schoolName: string;
  year: number;
  _id?: string;
}

export interface Exercise {
  _id: string;
  matiere: string;
  submissionType: SubmissionType;
  referenceType: string;
  referenceBook: null | { name: string; page: number; exerciseNumber: number };
  referenceTest: null | {
    session: string;
    class: string;
    schoolName: string;
    year: number;
  };
  referenceOther: null | { info: string };
  productionFileIds: string[];
  subjectFileIds: string[];
  studentId: string;
  comment: string;
  idConversation: null | string;
  isActivated: boolean;
  status: ExerciseStatus;
  correctorId: null | string;
  supervisorId: null | string;
  createdAt: string;
  updatedAt: string;
  __v?: number;
  observation?: string;
}

export interface MessageProps {
  _id: string;
  sender: string;
  status: "Envoyé" | "Vu";
  body:
    | {
        type: "text";
        textContent?: string; // Permet à textContent d'être undefined
      }
    | {
        type: "pdf";
        _id: string;
        originalName: string;
        name: string;
        size: number;
        numberOfPages: number;
        textContent?: string;
        fileUrl: string;
      }
    | {
        type: "docx";
        _id: string;
        originalName: string;
        name: string;
        size: number;
        numberOfPages: number;
        textContent?: string;
        fileUrl: string;
      }
    | {
        type: "image";
        _id: string;
        originalName: string;
        name: string;
        size: number;
        numberOfPages: number;
        textContent?: string;
        fileUrl: string;
      };
  self: boolean;
  updatedAt: Date;
  timeAgo: string;
  menuOption?: boolean;
}

export type Conversation = {
  _id: string;
  conversationTitle: string;
  lastMessage: string;
  unreadMessages: number;
  timeAgo: string;
  createdAt: Date;
};
